import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Switch } from '@material-ui/core';
import { CheckOutlined, CloseOutlined } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import { colors } from './theme';
export const DefaultSwitch = (props) => {
    const classes = useStyles();
    return (_jsxs(Box, { position: 'relative', width: 'fit-content', children: [_jsx(Switch, { ...props }), props.checked ? (_jsx(CheckOutlined, { className: classes.checkIcon })) : (_jsx(CloseOutlined, { className: classes.closeIcon }))] }));
};
const useStyles = makeStyles({
    checkIcon: {
        position: 'absolute',
        fontSize: '0.875rem',
        top: 5,
        left: 16,
        color: colors.white
    },
    closeIcon: {
        position: 'absolute',
        fontSize: '0.875rem',
        top: 5,
        right: 16,
        color: colors.grey.DEFAULT
    }
});
